module.exports = __webpack_public_path__ + "static/media/groom.b04f6bbd.png";